import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { dlpInsuranceTypes } from "../../../Enums/enumValues";
import { ModelState } from "../../../interfaces/modelState";
import { Coverage, CoverageInsuranceType } from "../../../providers/dlpFlow/DlpFlow.interfaces";
import { Card } from "../../card/Card";
import { Fieldset } from "../../fieldset/Fieldset";
import DecimalInput from "../../InputFields/DecimalInput";
import SliderInput from "../../InputFields/SliderInput";
import { V5, V45 } from "../../InputFields/validator/validators";
import { RadioOption, VerticalRadioInput } from "../../InputFields/VerticalRadioInput";

interface Props {
  fields: Record<string, Field<string>>;
  modelState: ModelState | null;
  setModelState: (modelState: ModelState) => void;
  disabled: boolean;
  coverage: Partial<Coverage>;
  validationPropertyName: string;
  index: number;
  onUpdateCoverageInsuranceType: (index: number, insuranceType: CoverageInsuranceType) => void;
  onUpdateCoverageReductionRate: (index: number, reductionRate: number | undefined) => void;
}

export const InsuranceType = ({
  disabled,
  fields,
  coverage,
  validationPropertyName,
  modelState,
  onUpdateCoverageInsuranceType,
  onUpdateCoverageReductionRate,
  index,
  setModelState,
}: Props) => {
  const minReductionRate = 1.0;
  const maxReductionRate = 12.0;
  const step = 0.1;

  const resetModelStateOnUpdateCoverageReductionRate = (v: number) => {
    if (modelState) {
      delete modelState[`${validationPropertyName}.ReductionRate`];
    }
    setModelState({ ...modelState });
    onUpdateCoverageReductionRate(index, v);
  };

  const updateCoverageReductionRate = (reductionRate: number | undefined) => {
    onUpdateCoverageReductionRate(index, reductionRate);
  };

  const updateCoverageInsuranceType = (insuranceType: CoverageInsuranceType) => {
    onUpdateCoverageInsuranceType(index, insuranceType);
  };

  const id = `coverage-${index}-insurance-type`;
  const headingId = `${id}-heading`;

  return (
    <Fieldset aria-labelledby={headingId} disabled={disabled}>
      <Card>
        <h2 id={headingId}>
          <Text field={fields.InsuranceTypeTitle}></Text>
        </h2>
        <VerticalRadioInput
          required
          fieldData={fields}
          selectedRadioItem={coverage.insuranceType}
          wrapOptionInDiv="Yes"
          onChange={updateCoverageInsuranceType}
          name={`Insurancetype${index}`}
          id={`insurance_type_${index}`}
          modelState={modelState}
          propertyName={`${validationPropertyName}.Insurancetype`}
          options={dlpInsuranceTypes() as RadioOption<CoverageInsuranceType>[]}
        />
        {coverage.insuranceType === "Annuity" && (
          <>
            <DecimalInput
              required
              fieldData={fields}
              id={`reduction_rate_${index}`}
              name="ReductionRate"
              step={0.01}
              inputValue={coverage.reductionRate}
              modelState={modelState}
              validators={[V5, V45(minReductionRate, maxReductionRate)]}
              setModelState={setModelState}
              propertyName={`${validationPropertyName}.ReductionRate`}
              onChange={updateCoverageReductionRate}
            />
            <SliderInput
              fieldData={fields}
              id={`annuity_percentage_slider_${index}`}
              name="AnnuityPercentageSlider"
              min={minReductionRate}
              max={maxReductionRate}
              step={step}
              inputValue={coverage.reductionRate}
              defaultInputValue={minReductionRate}
              onChange={resetModelStateOnUpdateCoverageReductionRate}
            />
          </>
        )}
      </Card>
    </Fieldset>
  );
};
